import { useRef, useState, useEffect } from 'react';

export default function CodeInput({ length = 6, onChange }) {
    const [values, setValues] = useState(Array(length).fill(''));
    const inputsRef = useRef([]);

    useEffect(() => {
        const code = values.join('');
        onChange?.(code);
    }, [values, onChange]);

    const handleChange = (i, e) => {
        const val = e.target.value.replace(/\D/g, '').slice(0, 1);
        const newValues = [...values];
        newValues[i] = val;
        setValues(newValues);

        if (val && i < length - 1) {
            inputsRef.current[i + 1]?.focus();
        }
    };

    const handleKeyDown = (i, e) => {
        if (e.key === 'Backspace') {
            const newValues = [...values];
            if (values[i]) {
                newValues[i] = '';
                setValues(newValues);
            } else if (i > 0) {
                inputsRef.current[i - 1]?.focus();
                newValues[i - 1] = '';
                setValues(newValues);
            }
        }
    };

    const handlePaste = (e) => {
        const pasted = e.clipboardData.getData('Text').slice(0, length).replace(/\D/g, '');
        const newValues = [...values];
        for (let i = 0; i < pasted.length; i++) {
            newValues[i] = pasted[i];
        }
        setValues(newValues);
    };

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '12px',
            padding: '8px 0',
            flexWrap: 'nowrap',
        }}>
            {values.map((val, i) => (
                <input
                    key={i}
                    value={val}
                    onChange={e => handleChange(i, e)}
                    onKeyDown={e => handleKeyDown(i, e)}
                    onPaste={handlePaste}
                    ref={el => inputsRef.current[i] = el}
                    type="text"
                    inputMode="numeric"
                    maxLength={1}
                    style={{
                        width: '48px',
                        height: '48px',
                        fontSize: '20px',
                        fontWeight: '700',
                        textAlign: 'center',
                        border: 'none',
                        borderRadius: '12px',
                        boxShadow: '0 0 4px rgba(0,0,0,0.1)',
                        outline: 'none',
                        backgroundColor: 'white',
                    }}
                />
            ))}
        </div>
    );
}
